// extracted by mini-css-extract-plugin
module.exports = {"categoryTag":"category-tag_categoryTag__nHioO"};